module.exports = __webpack_public_path__ + "images/emoji/negative_squared_cross_mark.293ac1b1cefed46267b7.png";